import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

interface ErrorPageProps {
  mode?: '404' | '500';
}

export default function ErrorPage({ mode = '404' }: ErrorPageProps) {
  const is404 = mode === '404';

  return (
    <div className="min-h-screen bg-paper flex flex-col items-center justify-center p-6 text-center overflow-hidden relative">
      <SEO title={is404 ? 'Halaman Tidak Ditemukan' : 'Kesalahan Server'} />
      
      {/* Artistic background text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <motion.span 
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 0.03, scale: 1 }}
          transition={{ duration: 2 }}
          className="text-[40vw] font-serif font-bold text-brand-wine select-none"
        >
          {is404 ? '404' : '500'}
        </motion.span>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="relative z-10 max-w-lg"
      >
        <h1 className="text-3xl md:text-5xl font-serif text-ink mb-6 leading-tight">
          {is404 ? 'Ruang yang Tidak Ditemukan' : 'Melangkah Terlalu Jauh'}
        </h1>
        
        <p className="text-sm text-muted/70 leading-relaxed mb-12 max-w-md mx-auto">
          {is404 
            ? 'Maaf, halaman yang Anda cari telah berpindah atau tidak pernah ada dalam koleksi kami.'
            : 'Sepertinya kami sedang mengalami kendala teknis. Silakan coba beberapa saat lagi.'}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/" 
            className="px-10 py-4 bg-brand-wine text-white text-[10px] font-black uppercase tracking-[0.2em] hover:bg-brand-wine-deep transition-all rounded-full shadow-lg shadow-brand-wine/10"
          >
            Kembali ke Beranda
          </Link>
          <Link 
            to="/shop" 
            className="px-10 py-4 bg-transparent border border-brand-wine/20 text-brand-wine text-[10px] font-black uppercase tracking-[0.2em] hover:bg-brand-wine/5 transition-all rounded-full"
          >
            Jelajahi Koleksi
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
